exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#clinic-show-availability .modal-dialog{max-width:50%}", ""]);

// exports
